import React from 'react'

import { Button } from '@UI/Button'
import { Modal } from '@UI/Modal'

import s from './ConfirmPopup.module.scss'
import { ConfirmPopupProps } from './ConfirmPopup.props'

export function ConfirmPopup({ title, description, confirmBtnLabel, onClose, onConfirm }: ConfirmPopupProps) {
  return (
    <Modal
      title={title}
      onClose={onClose}
    >
      <p className={s.description}>{description}</p>

      <div className={s.wrapper}>
        <Button
          variant="border"
          onClick={onClose}
          className={s.btn}
          fulFill
        >
          відмінити
        </Button>

        <Button
          onClick={onConfirm}
          className={s.btn}
        >
          {confirmBtnLabel}
        </Button>
      </div>
    </Modal>
  )
}
